<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.seller && localService.languageContent.receipt">
    <div class="banner center" style="max-width:1000px;">
        <div class="row freeze_height">
            <div class="col-6">
                <div class="row">
                    <div class="col-md-5">
                        <button class="button_icon button_icon_color icon_adjust"
                            (click)="onAction(5)">arrow_back</button>
                        <span class="en">{{onGetReceiptTypeName()}}</span>
                        &nbsp;
                        <span class="en" *ngIf="sourcerReceiptOptions && receiptOptions">{{receiptOptions.length}}/{{sourcerReceiptOptions.length}}</span>
                    </div>
                    <div class="col-md-7">
                        <input autocomplete="off" [disabled]="isShowRawCode" type="text"
                            style="margin-bottom: 10px;float: right;margin-top: 10px;" [(ngModel)]="searchKey"
                            title="{{localService.languageContent.common.search}}" id="{{elementIds.txt_search_key}}"
                            placeholder="{{localService.languageContent.common.search}}" (input)="onAction(1)" />
                    </div>
                </div>
            </div>
            <div class="col-2" style="text-align: right;">
                <button class="button_icon button_icon_color icon_adjust" (click)="onAction(9)"
                    style="margin-right: 20px !important;">sync</button>
                <button class="button_icon button_icon_color icon_adjust" (click)="onAction(4)">{{isShowRawCode ?
                    'raw_on' : 'raw_off'}}</button>
            </div>
            <div class="col-4" style="text-align: right;">
                <label style="margin-left:20px;font-weight:normal;" class="en" title="Show only filled html"
                    *ngIf="!isShowRawCode">
                    <input type="checkbox" [(ngModel)]="isShowOnlyFilledHtml">
                    <span style="color:darkslategrey">&nbsp;Show only filled html&nbsp;</span>
                </label>
                <button type="button" class="btn btn-secondary"
                    (click)="onAction(2)">{{localService.languageContent.common.save}}</button>
            </div>
        </div>
        <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
            <div *ngIf="!isShowRawCode">
                <div *ngFor="let item of receiptOptions">
                    <div class="row styled_row"
                        *ngIf="!isShowOnlyFilledHtml || (isShowOnlyFilledHtml && isHtmlAvailable(item.key))">
                        <div class="col-12">
                            <div class="row">
                                <div class="col-6">
                                    <label> {{item.value}} - ({{item.key}}) </label>
                                </div>
                                <div class="col-4 en">
                                    <label style="margin-left:20px;font-weight:normal;" title="Is Loop">
                                        <input type="checkbox" [checked]="isLoop(item.key)"
                                            (click)="onAction(7,item.key)">
                                        <span style="color:darkslategrey">&nbsp;Is Loop?</span>
                                    </label>
                                </div>
                                <div class="col-2" style="text-align: right;">
                                    <button class="button_icon button_icon_color icon_adjust"
                                        (click)="onAction(6,item.key)">more_horiz</button>
                                </div>
                            </div>
                            <div *ngFor="let itemHtml of currentReceiptHtml">
                                <div class="row" *ngIf="itemHtml.key.toString() == item.key">
                                    <div [ngClass]="expandedKey == item.key ? 'col-md-5' : 'col-md-12'" class="">
                                        <textarea rows="6" [(ngModel)]="itemHtml.value"
                                            placeholder="{{localService.languageContent.receipt.html}} - {{item.value}}"
                                            title="{{localService.languageContent.receipt.html}} - {{item.value}}"
                                            (blur)="onAction(8,item.key)"
                                            (keydown)="localService.handleTabForTextArea($event)"></textarea>
                                    </div>
                                    <div class="col-md-7 en"
                                        *ngIf="expandedKey == item.key && itemHtml.values && itemHtml.values.length > 0">
                                        <div class="row styled_row"
                                            *ngFor="let itemHtmlOptionContains of itemHtml.values">
                                            <div class="col-6">
                                                <span>{{itemHtmlOptionContains.key + ' - ' +
                                                    localService.onGetReceiptOptionContainsText(itemHtmlOptionContains.key)}}</span>
                                            </div>
                                            <div class="col-6">
                                                <input autocomplete="off" type="text"
                                                    [(ngModel)]="itemHtmlOptionContains.value"
                                                    placeholder="Comma separated numbers"
                                                    title="Comma separated numbers" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="isShowRawCode" style="text-align: center;margin-top: 3px;">
                <textarea [ngStyle]="{'height' : (maxBodyHeight - 15) + 'px'}" [(ngModel)]="currentReceiptHtmlJson"
                    placeholder="Enter your JSON value here.."></textarea>
            </div>
        </div>
    </div>
</div>